module.exports = __webpack_public_path__ + "static/media/cq_login.408447e8.svg";